<template>
  <section class="d-flex servicessection">
    <b-container class="py-5 px-5">
      <h2>Our capabilities are everything.</h2>
      <b-row class="py-4" v-for="(service, index) in services" :key="service.heading">
        <b-col>
          <b-row>
            <b-col cols="1" class="d-none d-md-flex">
              <b-icon font-scale="3" icon="hexagon-fill" variant="primary"></b-icon>
            </b-col>
            <b-col cols="11">
                <b-row class="pb-3">
                  <b-col cols="12" order="1">
                    <h5>{{service.heading}}</h5>
                  </b-col>
                </b-row>
                <b-row class="pb-3">
                  <b-col cols="12" lg="7" order="3" class="mr-auto" :order-lg="ordering(index)">
                    <p>{{service.content}}</p>
                  </b-col>
                  <b-col cols="12" lg="4" order="2" class="mr-auto" :order-lg="ordering(index+1)">
                    <b-img-lazy blank-color="#777" rounded offset="500" class="py-2" :src="require(`@/assets/services/${service.image}`)" fluid></b-img-lazy>
                  </b-col>
                </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  name: "services",
  data() {
    return {
      services: [
          {
            heading: "Artwork Production",
            content: "Having an eye for creativity and being firmly grounded in the technical know-how for preparing" +
                " press-ready artwork is a large part of our core graphic services. By working with your specifications and" +
                " our printer partners, we create press-ready artwork that will maintain the integrity of the original " +
                "design and is destined to perform with excellent results throughout the printing process.",
            image: "artist.jpg"
        },
        {
          heading: "Prepress Process",
          content: "Paired closely with artwork preparation and driven by automation and efficient workflow strategies," +
              " our prepress process brings to the table years of experience, technical prowess and industry leading" +
              " software and hardware solutions. We offer a full suite of prepress services that pave the way to" +
              " providing our partners with predictable, reliable, and successful means in which to achieve outstanding results on press.",
          image: "prepress.jpg"
        },
        {
          heading: "Color Contract Proofing",
          content: "The primary goal of proofing is to provide a cost effective way for our partners to verify that a" +
              " job is completely accurate in color and content prior to going to press with a design. Through the use" +
              " of superior materials, equipment and software for output, measurement and data analysis," +
              " Impact Imaging Group’s color reproduction proofs will provide an extremely accurate glimpse of what one" +
              " can expect on the final printed package.",
          image: "proofing.jpg"
        },
        {
          heading: "Flexo Plate Imaging and Manufacturing",
          content: "Image carriers are the rubber that hits the road in printing. We have invested heavily in imaging" +
              " and processing equipment that enable us to produce the best flexographic printing plates in the market." +
              " Impact Imaging Group has partnered with industry leading sheet photopolymer manufacturers and invested" +
              " in a 50” x 80” Luscher plate imaging device. Our Luscher is capable of imaging all available" +
              " calipers of flexo plates at full production speeds with 5080dpi resolution, the first of its kind in" +
              " North America. With this combined speed and resolution, coupled with industry leading photopolymer" +
              " plates and efficient manufacturing, the results speak for themselves in both production time and quality.",
          image: "lusher_blue.jpg"
        },
        {
          heading: "Flexo Plate Mounting",
          content: "Corrugated flexo plate mounters are the unsung heroes of our niche industry. In a flexo plate" +
              " manufacturing facility, such as ours, they are the last stop before jobs reach our printing partners'" +
              " facilities. This process is a craft all its own and requires critical accuracy, precision and efficiency." +
              " We’ve handled many of these hurdles by investing in equipment from industry innovation leaders in flexographic mounting." +
              " This equipment and their associated processes allow us to link the prepress process to the mounting process" +
              " and create data-driven device functionality.",
          image: "mounting.jpg"
        },
      ]
    }
  },
  methods: {
    evenNumber(num) {
      return num % 2 ==0;
    },
    ordering(num) {
      if (num % 2 == 0) {
        return 1;
      }
      return 2;
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/custom';

.servicessection {
  min-height: 700px;
  border-top: 3px solid $primary;
  background: url('~@/assets/honeycomb-right.png') no-repeat bottom right;
  background-color: $gray-300;

  ul {
    li {
      list-style: none;
    }
  }

  .serviceimages img {
    @media screen and (max-width: 767px) {
      padding: 10px;
      display: block;
    }
  }
}

</style>